import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        classifiers: '='
    },
    template: `
    <div class="loader02" ng-if="vm.saving">
        <p>{{ 'question.Please wait' | translate }}</p>
    </div>
    <div class="colholder mt10 w100p">
        <div class="col col11">
            <list-search
                model="vm.filter.name"
                placeholder="{{ 'skill.Search by name' | translate }}"
                on-change="vm.onSearchChanged()">
            </list-search>
        </div>
        <div class="col col10">
            <ul class="actions01 nomargin f-right">
                <li class="primary">
                    <a class="btn main nowrap" ng-click="vm.add()">{{ 'skill.Add skill' | translate }}</a>
                </li>
            </ul>
        </div>
    </div>

    <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>

    <div class="well" ng-if="vm.list.items.length && !vm.list.loading">
        <pagination-tools list="vm.list"></pagination-tools>
        <table class="data01" datatable dt-options="vm.DATATABLES">
            <thead>
                <tr>
                    <th ng-class="vm.list.getSortClass('name')">
                        <a ng-click="vm.list.sortBy('name')">{{ 'skill.Skill' | translate }}</a>
                    </th>
                    <th>{{ 'skill.Skill overview' | translate }}</th>
                    <th ng-class="vm.list.getSortClass('scale_id')">
                        <a ng-click="vm.list.sortBy('scale_id')">{{ 'skill.Associated scale' | translate }}</a>
                    </th>
                    <th>{{ 'skill.Code' | translate }}</th>
                    <th ng-class="vm.list.getSortClass('is_active')">
                        <a ng-click="vm.list.sortBy('is_active')">{{ 'skill.Status' | translate }}</a>
                    </th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr ng-repeat="skill in vm.list.items track by skill.id">
                    <td>
                        <a ui-sref="authorized.user.skill.edit.skill({ id: skill.id })">
                            {{ vm.getSkillName(skill) }}
                        </a>
                    </td>
                    <td>{{ vm.getSkillDescription(skill) }}</td>
                    <td>
                        {{ skill.scale && skill.scale.activeI18n ? skill.scale.activeI18n.name : ('Scale #' + skill.scaleId) }}
                    </td>
                    <td>{{ skill.code }}</td>
                    <td>
                        <label class="switch01 visible-label" style="width: fit-content;">
                            <input type="checkbox"
                                   ng-model="skill._isActiveUi"
                                   ng-init="skill._isActiveUi = skill.isActive"
                                   ng-disabled="skill._toggling"
                                   ng-change="vm.toggleActive(skill)">
                            <span>{{ (skill.isActive)
                                ? ('skill.Active' | translate)
                                : ('skill.Inactive' | translate) }}</span>
                        </label>
                    </td>
                    <td class="actions">
                        <action-menu button-label="{{ 'general.Actions' | translate }}">
                            <li>
                                <a ng-click="vm.viewUsers(skill)">
                                    {{ 'skill.View user list' | translate }}
                                </a>
                            </li>
                            <li>
                                <a ui-sref="authorized.user.skill.edit.skill({ id: skill.id })">
                                    {{ 'general.Edit' | translate }}
                                </a>
                            </li>
                            <li>
                                <a ng-click="vm.confirmDelete(skill)">
                                    {{ 'general.Delete' | translate }}
                                </a>
                            </li>
                        </action-menu>
                    </td>
                </tr>
            </tbody>
        </table>
        <pagination list="vm.list"></pagination>
    </div>
    `
})
export default class {
    constructor ($rootScope, $state, $timeout, $translate, lodash, toastr, DATATABLES,
                 ListFactory, SkillResource, ModalService, PrivilegeService, TokenService, UserSkillResource,
                 I18nService, $compile, $, UserSkillService, SkillActivationService) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.lodash = lodash;
        this.toastr = toastr;
        this.$compile = $compile;
        this.$ = $;
        this.SkillActivationService = SkillActivationService;
        this.responsiveScopes = new Map();

        // Define responsive renderer inline without using DatatableService
        this.DATATABLES = this.lodash.merge({}, DATATABLES, {
            responsive: {
                details: {
                    renderer: (api, rowIdx) => {
                        const [rowIndex] = rowIdx;
                        const $newScope = this.$rootScope.$new();
                        $newScope.vm = this;
                        $newScope.skill = this.list.items[rowIndex];

                        // Store the scope reference for this skill
                        const skillId = this.list.items[rowIndex].id;
                        this.responsiveScopes.set(skillId, $newScope);

                        // Clean up scope when destroyed
                        $newScope.$on('$destroy', () => {
                            this.responsiveScopes.delete(skillId);
                        });

                        const data = api.cells(rowIdx, ':hidden').eq(0).map((cell) => {
                            const header = this.$(api.column(cell.column).header());
                            let cn = this.$(api.cell(cell).nodes()).attr('class');
                            if (cn === undefined) {
                                cn = '';
                            }
                            cn = cn.replace('hidden', '');
                            const html = this.$(api.cell(cell).nodes()).html().replace('ng-non-bindable=""', '');
                            return `
                                <div class="row ${header.attr('class').replace('hidden', '')}">
                                    <div class="cell-label">${header.text()}</div>
                                    <div class="cell-value ${cn}">${html}</div>
                                </div>
                            `;
                        }).toArray().join('');

                        const returnVal = data ? this.$compile(this.$('<div />').append(data))($newScope) : false;
                        this.$timeout(() => {
                            if (!$newScope.$$phase) {
                                $newScope.$digest();
                            }
                        }, 0);
                        return returnVal;
                    }
                }
            }
        });
        this.ListFactory = ListFactory;
        this.SkillResource = SkillResource;
        this.ModalService = ModalService;
        this.PrivilegeService = PrivilegeService;
        this.TokenService = TokenService;
        this.I18nService = I18nService;
        this.UserSkillService = UserSkillService;

        this.defaultQuery = { expand: 'activeI18n,i18ns,scale,scale.scaleI18ns,scale.activeI18n,scale.proficiencies,scale.proficiencies.skillProficiencyI18n' };
        this.filter = this.lodash.assign({}, this.defaultQuery);
        this.skillProficiencies = [];
        this.list = ListFactory.createWithPagination(SkillResource.query.bind(SkillResource));
        // Let backend handle default sort order (is_active DESC, name ASC)
        this.list.fetch(this.filter);

        this.saving = false;

        this.perPage = 20; // default; keep in sync with backend pagination default if needed
        if (this.list.pagination) this.perPage = this.list.pagination.perPage || this.perPage;
    }

    onSearchChanged () {
        this.list.pagination.page = 1;
        this.list.fetch(this.filter);
    }

    getSkillName (skill) {
        if (skill && skill.activeI18n && skill.activeI18n.name) {
            return skill.activeI18n.name;
        }

        return `#${skill.id}`;
    }

    getSkillDescription (skill) {
        if (skill && skill.activeI18n && skill.activeI18n.description) {
            return skill.activeI18n.description;
        }

        return '';
    }

    getSkillProficiencies (skill) {
        if (!skill.scale || !skill.scale.proficiencies) return [];
        const activeLang = this.I18nService.getPreferredI18n(skill.scale.scaleI18ns);

        this.skillProficiencies = skill.scale.proficiencies.map(proficiency => ({
            id: proficiency.id,
            scaleId: proficiency.scaleId,
            points: proficiency.points,
            // Extract I18n values by language (ET, EN, RU)
            translations: Object.entries(proficiency.skillProficiencyI18n || {})
                .filter(([lang]) => lang === activeLang.language)
                .map(([lang, value]) => ({
                    language: lang,
                    value: value.value || ''
                }))
        }));

        return this.skillProficiencies;
    }

    changePerPage () {
        const n = parseInt(this.perPage, 10) || 20;
        if (this.list.pagination) this.list.pagination.perPage = n;
        this.list.pagination.page = 1;
        this.list.fetch(this.filter);
    }

    add () {
        this.ModalService.open({
            template: `
            <div class="modal-header" id="modal-header">
                <div class="heading01 heading01b">
                    <h2>{{ 'skill.Add skill' | translate }}</h2>
                    <ul class="actions01">
                        <li class="primary">
                            <a class="btn main" ng-click="vm.formApi.save()">
                                {{ 'general.Add' | translate }}
                            </a>
                        </li>
                        <li>
                            <a class="btn bordered02" ng-click="vm.$uibModalInstance.dismiss()">
                                {{ 'general.Cancel' | translate }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="modal-body">
                <user-skill-form-skill
                    mode="add"
                    uib-modal-instance="vm.$uibModalInstance"
                    api="vm.formApi">
                </user-skill-form-skill>
            </div>
        `,
            size: 'large',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.formApi = {}; // filled by child
            }
        }).then(() => {
            this.list.fetch(this.filter);
        }).catch(() => {});
    }

    viewUsers (skill) {
        this.getSkillProficiencies(skill);
        return this.ModalService.open({
            template: `
                <modals-user-skills-users
                    classifiers="vm.classifiers"
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    skill="vm.skill"
                    proficiencies="vm.proficiencies"
                ></modals-user-skills-users>
            `,
            size: 'xlarge',
            resolve: {
                classifiers: () => this.classifiers,
                proficiencies: () => this.skillProficiencies,
                skills: () => skill
            },
            controller ($uibModalInstance, classifiers, proficiencies) {
                this.$uibModalInstance = $uibModalInstance;
                this.skill = skill;
                this.classifiers = classifiers;
                this.proficiencies = proficiencies;
            }
        }).then(() => {});
    }

    toggleActive (skill) {
        if (!skill || skill._toggling) return;
        const next = !!skill._isActiveUi;
        skill._toggling = true;

        this.SkillActivationService.checkAndConfirm(skill.id)
            .then((result) => {
                if (result.proceed) {
                    const showLoader = result.affectedApgs && result.affectedApgs.length > 0;
                    return this.performActivation(skill, next, showLoader);
                }
                // User cancelled, revert UI
                skill._isActiveUi = !!skill.isActive;
                return null;
            })
            .catch(() => {
                skill._isActiveUi = !!skill.isActive;
                this.toastr.error(this.$translate.instant('skill.Failed to check APG connections'));
            })
            .finally(() => {
                skill._toggling = false;
            });
    }

    performActivation (skill, next, showLoader) {
        if (showLoader) this.saving = true;
        return this.SkillResource.activation({ id: skill.id }, { is_active: next }).$promise
            .then(() => {
                skill.isActive = next;
                skill._isActiveUi = next;
                const msg = next
                    ? this.$translate.instant('skill.Skill enabled')
                    : this.$translate.instant('skill.Skill disabled');
                this.toastr.success(msg);
            })
            .catch((err) => {
                skill._isActiveUi = !!skill.isActive;
                const msg = next
                    ? this.$translate.instant('skill.Enable failed')
                    : this.$translate.instant('skill.Disable failed');
                this.toastr.error(err && err.data && err.data.message ? err.data.message : msg);
            })
            .finally(() => {
                this.saving = false;
            });
    }

    confirmDelete (skill) {
        const loadUserCount = () => {
            return this.UserSkillService.countUsers(skill.id);
        };

        loadUserCount().then((usersCount) => {
            const warnTitle = this.$translate.instant('skill.Delete skill');
            const warnBody = `${this.$translate.instant('skill.DeleteWarningMessage')} ${usersCount}`;
            return this.ModalService.confirm(`${warnTitle}<br>${warnBody}`, 'large')
                .then(() => this.SkillResource.delete({ id: skill.id }).$promise)
                .then(() => {
                    this.toastr.success(this.$translate.instant('skill.Skill deleted'));
                    this.list.fetch(this.filter);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/skill/list/skill/index.js